import { numericUtil } from '@cmg/common';
import { createPercentageFilterValueGetter, createValueFormatter } from '@cmg/data-grid';

import type { CalendarGridColDef, CalendarGridRowData } from '../../CalendarGrid.model';
import { POSITIVE_NEGATIVE_VALUE_CELL_CLASS_RULES } from '../../CalendarGrid.model';

export type Value = NonNullable<CalendarGridRowData['attributes']>['pctOfferTo1Day'];

const PRECISION = 2;
const FIELD = 'attributes.pctOfferTo1Day';

export const valueFormatter = createValueFormatter<CalendarGridRowData, Value>({
  gridRow: ({ value }) => numericUtil.getDisplayValueForPercents(value, PRECISION),
});

export const filterValueGetter = createPercentageFilterValueGetter<CalendarGridRowData>({
  field: FIELD,
  precision: PRECISION,
});

const pctToOneDayColDef: CalendarGridColDef<Value> = {
  field: FIELD,
  headerName: '1 Day %',
  width: 96,
  type: ['numericColumn', 'number'],
  filter: 'agNumberColumnFilter',
  valueFormatter,
  filterValueGetter,
  cellClassRules: POSITIVE_NEGATIVE_VALUE_CELL_CLASS_RULES,
};

export default pctToOneDayColDef;
